import { Spacing } from "@dls/web";
import styled from "styled-components";

export const SelectContainer = styled(Spacing)`
  height: 5.5rem;
`;
